import extraHeaders from './interceptors/injectAppHeaders/extraHeaders';
import { getTravelerInfoHeader } from './interceptors/injectTravelerHeader';

import getApplicationId from '../core/applicationId/getApplicationId';
import { REQUEST_HEADERS, TRAVELER_INFO_HEADER_KEY } from '../constants';
import { getTmcId } from '../core/tmcId/getTmcId';
import { getOrgId } from '../core/orgId/getOrgId';

export interface IExtraHeaders {
  'x-app-type': string;
  'x-app-platform': string;
  'x-app-version': string;
}

export interface IApplicationServerHeaders extends IExtraHeaders {
  'x-application-id'?: string;
  'spotnana-traveler-info': string;
  authorization: string;
}

async function getApplicationServerHeaders(
  getAuthToken: () => Promise<string>,
  preferredCurrency: string,
): Promise<IApplicationServerHeaders> {
  const token = await getAuthToken();
  const travelerInfo = await getTravelerInfoHeader(preferredCurrency);
  const applicationId = await getApplicationId();
  const tmcId = await getTmcId();
  const orgId = await getOrgId();

  const headers: IApplicationServerHeaders = {
    ...extraHeaders,
    ...(applicationId ? { 'x-application-id': applicationId } : {}),
    ...(tmcId ? { [REQUEST_HEADERS.X_TMC_ID]: tmcId } : {}),
    ...(orgId ? { [REQUEST_HEADERS.X_ORG_ID]: orgId } : {}),
    [TRAVELER_INFO_HEADER_KEY]: travelerInfo,
    authorization: `Bearer ${token}`,
  };

  return headers;
}

export default getApplicationServerHeaders;
